export interface ChatMessage {
    id: string;
    content: string;
    timestamp: Date;
    sender: MessageSender;
    type: MessageType;
    status?: MessageStatus;
  }
  
  export interface MessageSender {
    id: string;
    name: string;
    type: 'user' | 'agent' | 'system';
    avatar?: string;
  }
  
  export enum MessageType {
    TEXT = 'text',
    IMAGE = 'image',
    FILE = 'file',
    SYSTEM = 'system'
  }
  
  export enum MessageStatus {
    SENDING = 'sending',
    SENT = 'sent',
    DELIVERED = 'delivered',
    READ = 'read',
    ERROR = 'error'
  }
  
  export interface ChatSession {
    id: string;
    userId: string;
    agentId?: string;
    status: ChatStatus;
    createdAt: Date;
    updatedAt: Date;
    messages: ChatMessage[];
    unreadCount: number;
  }
  
  export enum ChatStatus {
    ACTIVE = 'active',
    WAITING = 'waiting',
    CLOSED = 'closed',
    TRANSFERRED = 'transferred'
  }
  
  export interface ChatConfiguration {
    maxMessages: number;
    autoClose: boolean;
    autoCloseTime: number; 
    showTypingIndicator: boolean;
    allowFileUpload: boolean;
    maxFileSize: number;
    welcomeMessage?: string;
  }
  
  export interface TypingIndicator {
    isTyping: boolean;
    sender: MessageSender;
    timestamp: Date;
  }